import { render, staticRenderFns } from "./AdminCommonLayout.vue?vue&type=template&id=54194d9e"
import script from "./AdminCommonLayout.vue?vue&type=script&lang=js"
export * from "./AdminCommonLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports